// extracted by mini-css-extract-plugin
export default {"section_reactions":"ReactionButton_section_reactions__-5UCR","active":"ReactionButton_active__g-KRo","shake":"ReactionButton_shake__0pqxp"};